const { debounce } = require('lodash');

export default function observeMenuState() {
  const NAV_DROPDOWN_OPENED_CLASS = 'nav-dropdown_opened';

  const menu = document.querySelector('.js-navbar');
  const menuNav = menu.querySelector('.js-drop-list');
  const menuButton = menu.querySelector('.js-toggle-button');
  const dropdowns = menu.querySelectorAll('.js-nav-dropdown');

  // Helpers

  function menuIsOpened() {
    return menuNav.classList.contains('show');
  }

  function isLaptopMode() {
    const documentWidth = (
      document.body.clientWidth
      || document.documentElement.clientWidth
      || window.innerWidth
    );
    const MIN_LAPTOP_WIDTH = 992;

    return documentWidth >= MIN_LAPTOP_WIDTH;
  }

  // DOM manipulations

  function showHeader() {
    menu.classList.remove('transparent');
    menu.classList.add('colored');
  }

  function hideHeader() {
    menu.classList.remove('colored');
    menu.classList.add('transparent');
    menu.addEventListener('transitionend', () => {
      menu.classList.remove('transparent');
    }, { once: true });
  }

  function activateBodyScrolling() {
    document.body.style.overflowY = 'hidden';
  }

  function unactivateBodyScrolling() {
    document.body.style.overflowY = 'auto';
  }

  // Handlers

  function handleWindowResize() {
    if (isLaptopMode() && menuIsOpened()) {
      hideHeader();
      unactivateBodyScrolling();
    } else if (!isLaptopMode() && menuIsOpened()) {
      showHeader();
      activateBodyScrolling();
    }
  }

  function handleMenuButtonClick() {
    if (isLaptopMode()) return;

    if (menuIsOpened()) {
      hideHeader();
      unactivateBodyScrolling();
    } else {
      showHeader();
      activateBodyScrolling();
    }
  }

  function handleDropdownClick(e) {
    const button = e.currentTarget;
    const isDropdownOpened = button.classList.contains(NAV_DROPDOWN_OPENED_CLASS);

    if (isDropdownOpened) {
      button.classList.remove(NAV_DROPDOWN_OPENED_CLASS);
    } else {
      button.classList.add(NAV_DROPDOWN_OPENED_CLASS);
    }
  }

  function handleDropdownMouseleave(e) {
    if (!isLaptopMode()) return;

    const button = e.currentTarget;
    const isDropdownOpened = button.classList.contains(NAV_DROPDOWN_OPENED_CLASS);

    if (isDropdownOpened) {
      button.classList.remove(NAV_DROPDOWN_OPENED_CLASS);
    }
  }

  window.addEventListener('resize', debounce(handleWindowResize, 50));
  menuButton.addEventListener('click', handleMenuButtonClick);
  dropdowns.forEach((item) => {
    item.addEventListener('click', handleDropdownClick);
    item.addEventListener('mouseleave', handleDropdownMouseleave);
  });
}
